export const homeDetailsRootSx = {
  height: 'calc(100vh - 130px)',
  minHeight: 0,
  overflow: 'hidden'
};

export const homeDetailsPaperWrapperSx = {
  height: '100%',
  minHeight: 0,
  overflow: 'hidden'
};

export const homeDetailsGridSx = {
  height: '100%',
  minHeight: 0,
  overflow: 'hidden'
};

export const homeDetailsGridItemSx = {
  display: 'flex',
  height: '100%',
  minHeight: 0,
  overflow: 'hidden'
};

export const homeDetailsColumnWrapperSx = {
  display: 'flex',
  flex: 1,
  minHeight: 0,
  overflow: 'hidden'
};